import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const orientProject = (project) => api.post(`/ai/orient`, { project }).then((r) => r.data);
export const submitContact = (payload) => api.post(`/contact`, payload).then((r) => r.data);

// Auth
export const apiRegister = (payload) => api.post(`/auth/register`, payload).then((r) => r.data);
export const apiLogin = (payload) => api.post(`/auth/login`, payload).then((r) => r.data);
export const apiMe = () => api.get(`/auth/me`).then((r) => r.data);

// Portal
export const getDossiers = () => api.get(`/portal/dossiers`).then((r) => r.data);
export const getInvoices = () => api.get(`/portal/invoices`).then((r) => r.data);
export const getTickets = () => api.get(`/portal/tickets`).then((r) => r.data);
export const createTicket = (payload) => api.post(`/portal/tickets`, payload).then((r) => r.data);

// Blog (public)
export const getBlog = () => api.get(`/blog`).then((r) => r.data);

// Assistant
export const askAssistant = (question, session_id) => api.post(`/assistant/chat`, { question, session_id }).then((r) => r.data);
export const emailAnalysis = (email, question, answer) => api.post(`/assistant/email`, { email, question, answer }).then((r) => r.data);
export const getAssistantQueries = () => api.get(`/assistant/queries`).then((r) => r.data);

// Live news
export const getNews = (country) => api.get(`/news`, { params: { country } }).then((r) => r.data);

// Newsletter
export const subscribeNewsletter = (email, country) => api.post(`/newsletter/subscribe`, { email, country }).then((r) => r.data);
export const getNewsletter = () => api.get(`/newsletter/admin/list`).then((r) => r.data);
export const sendNewsletter = () => api.post(`/newsletter/admin/send`).then((r) => r.data);

// Admin
export const getClients = () => api.get(`/admin/clients`).then((r) => r.data);
export const createDossier = (payload) => api.post(`/admin/dossiers`, payload).then((r) => r.data);
export const updateDossier = (id, payload) => api.put(`/admin/dossiers/${id}`, payload).then((r) => r.data);
export const createInvoice = (payload) => api.post(`/admin/invoices`, payload).then((r) => r.data);
export const updateInvoice = (id, payload) => api.put(`/admin/invoices/${id}`, payload).then((r) => r.data);
export const createArticle = (payload) => api.post(`/admin/blog`, payload).then((r) => r.data);
export const updateArticle = (id, payload) => api.put(`/admin/blog/${id}`, payload).then((r) => r.data);
export const deleteArticle = (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data);

// Payments (Stripe)
export const createInvoiceCheckout = (invoice_id) =>
  api.post(`/payments/invoice/checkout`, { invoice_id, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);


// Careers (public)
export const getCareers = () => api.get(`/careers`).then((r) => r.data);
export const getCareer = (id) => api.get(`/careers/${id}`).then((r) => r.data);
export const applyToJob = (payload) => api.post(`/careers/apply`, payload).then((r) => r.data);
// Careers (admin)
export const adminListJobs = () => api.get(`/careers/admin/list`).then((r) => r.data);
export const adminCreateJob = (payload) => api.post(`/careers/admin`, payload).then((r) => r.data);
export const adminUpdateJob = (id, payload) => api.put(`/careers/admin/${id}`, payload).then((r) => r.data);
export const adminDeleteJob = (id) => api.delete(`/careers/admin/${id}`).then((r) => r.data);
export const adminListApplications = () => api.get(`/careers/admin/applications`).then((r) => r.data);


export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
